export default "__VITE_ASSET__BpqpBD8N__"